// Central place for all external brand links — update once, reflects everywhere.
export const LINKS = {
    // The canonical production domain — used (instead of window.location.origin)
    // wherever a link is generated for SHARING outside the app (e.g. the public
    // internship application link), so it always points at the real site even
    // if an admin happens to be browsing a preview/staging deployment URL.
    siteUrl: "https://www.thefinancialdoctor.in",
    assetPlus: "https://www.assetplus.in/mfd/ARN-290298",
    whatsappDM:
        "https://wa.me/917773805794?text=Hi%20Sagar%20ji%2C%20I%20want%20to%20know%20more%20about%20mutual%20fund%20investments.",
    whatsappCommunity: "https://chat.whatsapp.com/JEb2Ilngiq45oqyUQDMFSX",
    // Direct Google "Write a Review" deep-link for The Financial Doctor's GBP
    googleReviews: "https://g.page/r/CfuGBYdI9B_BEBE/review",
    googleReviewsFull: "https://g.page/r/CfuGBYdI9B_BEBE/review",
    // Google Maps listing — office location + turn-by-turn directions
    googleMaps:
        "https://www.google.com/maps/place/The+Financial+Doctor/@23.1986103,77.0696476,15z/data=!4m22!1m15!4m14!1m6!1m2!1s0x397cf312d707d7d7:0xc11ff448870586fb!2sThe+Financial+Doctor,+1st+Floor,+New+Bus+Stand,+Sekdakhedi+Road,+above+SK+Finance,+beside+Upadhyay+Honda+Showroom,+Badiyakheri,+Sehore,+Madhya+Pradesh+466001!2m2!1d77.08808!2d23.1985917!1m6!1m2!1s0x397cf312d707d7d7:0xc11ff448870586fb!2sThe+Financial+Doctor,+1st+Floor,+New+Bus+Stand,+Sekdakhedi+Road,+above+SK+Finance,+beside+Upadhyay+Honda+Showroom,+Badiyakheri,+Sehore,+Madhya+Pradesh+466001!2m2!1d77.08808!2d23.1985917!3m5!1s0x397cf312d707d7d7:0xc11ff448870586fb!8m2!3d23.1985917!4d77.08808!16s%2Fg%2F11krbqgqb6?entry=ttu&g_ep=EgoyMDI2MDcxNS4wIKXMDSoASAFQAw%3D%3D",
    // Google Business Profile — reviews, photos, hours, "Business" panel
    googleBusiness: "https://share.google/zLB8GGVcqowN9sWKw",
    instagram: "https://www.instagram.com/the_financial.doctor",
    youtube: "https://youtube.com/@the_financial_doctor",
    linkedin: "https://www.linkedin.com/in/sagarchaturvedisehore",
    phone: "+917773805794",
    email: "wecare@thefinancialdoctor.in",
};

export default LINKS;
